import { Container, makeStyles, Theme } from '@material-ui/core';
import React from 'react';
import { useHistory } from 'react-router';
import { AmplitudeEventType } from '../../../../../../analytics/amplitudeEvents';
import { TextListWithTranslation } from '../../../../../../clientConfig/types';
import useConfigTranslate from '../../../../../hooks/useConfigTranslate';
import { ApiRequestLogger } from '../../../../../logger/apiRequestLogger';
import { useErrorHistoryPush } from '../../../../../util/errorUtils';
import withLogger from '../../../../HOC/WithLogger';
import { AuthenticatedRoutes } from '../../../../routers';
import { AnalyticsIdentityVerificationMethod } from '../../analytics';
import { ClearButton } from '../../clear';
import BasicButton from './BasicButton';
import { sendEventByOptions } from '../../../../../services/amplitudeClient';

type CardActionsProps = {
    buttonsList: TextListWithTranslation[];
    updateSessionCookie: (verificationSessionId: string) => void;
    jwt: string;
    token: string | undefined;
    isCrossRegion: boolean;
    log: ApiRequestLogger;
};

const useStyles = makeStyles<Theme, any, string>(() => ({
    root: {
        height: '100%',
        display: 'flex',
        alignItems: 'stretch',
        width: 'max-content',
        gap: 16,
        flexDirection: 'column',
    },
}));

const CardActions: React.FC<CardActionsProps> = ({
    buttonsList,
    updateSessionCookie,
    jwt,
    token,
    isCrossRegion,
    log,
}) => {
    const history = useHistory();
    const errorHistoryPush = useErrorHistoryPush();
    const configT = useConfigTranslate();
    const classes = useStyles({});

    const redirectToCustomerService = (error: Error) => {
        errorHistoryPush(
            AuthenticatedRoutes.VerificationRoutes.ContactCustomerService,
            `IdentityVerificationPage(): Error occurred - ${error.message}`,
        );
    };

    const useDemographicsFlow = () => {
        sendEventByOptions({
            eventType: AmplitudeEventType.IdentityVerification_MethodSelection_Select,
            eventProperties: {
                activation_method: AnalyticsIdentityVerificationMethod.SMS,
            },
        });
        history.push({
            pathname: AuthenticatedRoutes.VerificationRoutes.StartDemographicsFlow,
            state: { isCrossRegion },
        });
    };
    const useActivationCodeFlow = () => {
        sendEventByOptions({
            eventType: AmplitudeEventType.IdentityVerification_MethodSelection_Select,
            eventProperties: {
                activation_method: AnalyticsIdentityVerificationMethod.ACTIVATION_CODE,
            },
        });
        history.push(AuthenticatedRoutes.VerificationRoutes.ActivationCodeFlow);
    };

    return (
        <Container className={classes.root}>
            {buttonsList.map((button, index: number) => {
                if (button.name === 'ClearButton') {
                    return (
                        <ClearButton
                            key={index}
                            onError={redirectToCustomerService}
                            onSessionCreated={updateSessionCookie}
                            jwt={jwt}
                            token={token}
                            width={240}
                        >
                            {configT(button)}
                        </ClearButton>
                    );
                } else if (button.name === 'ActivationCode') {
                    return (
                        <BasicButton key={index} onClick={useActivationCodeFlow}>
                            {configT(button)}
                        </BasicButton>
                    );
                } else if (button.name === 'BasicActivation') {
                    return (
                        <BasicButton key={index} onClick={useDemographicsFlow}>
                            {configT(button)}
                        </BasicButton>
                    );
                }

                log.error(`Unknown button type: ${button.name}, button: ${JSON.stringify(button)}`);
                return null;
            })}
        </Container>
    );
};

export default withLogger(CardActions, {
    eventSource: 'CardActions',
});
